import React, { useEffect, useState } from "react";
import axios from "../axiosIn";
import { Heading } from "rsuite";
import { Image } from "react-bootstrap";


export const CierreEvento = () => {
  const [logo, setLogo] = useState("");
  const [fechaCarrera, setFechaCarrera] = useState("");

  const getData = async () => {
    const abortController = new AbortController();
    var url = `DatosCarrera/getDataInicio`;

    try {
      const response = await axios.get(url, { signal: abortController.signal });
      setLogo(response.data.LogoEquipo);
      setFechaCarrera(response.data.FechaCarrera);
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        console.log("Err_carga");
      }
    }
  };

	useEffect(() => {
		getData();
	},[])

  return (
    <div className="row">
      <div className="row">
        <div className="col text-center">
          <Image src={`Images/${logo}`} width={"250px"} height={"250px"} />
        </div>
      </div>
      <section className="row">
        <div className="row">
          <div class="col text-center">
            <Heading level={1}>¡Gracias!</Heading>
            <h2>Te esperamos en esta gran carrera, el próximo: {fechaCarrera}</h2>
            <h1>
              El horario de registro ha finalizado, gracias por tu
              participación!
            </h1>
          </div>
        </div>
        <br />
        <br />
      </section>
    </div>
  );
};
